import { createApp } from 'vue';
import vClickOutside from "click-outside-vue3";
import { createPinia } from 'pinia';

import App from '@/App.vue';
import '@/assets/css/app.scss';

const pinia = createPinia();
const app = createApp(App);

app.use(vClickOutside);
app.use(pinia);

app.mount('#app');
